import { render, staticRenderFns } from "./SantanderFisico.vue?vue&type=template&id=21d8e753&scoped=true&"
import script from "./SantanderFisico.vue?vue&type=script&lang=js&"
export * from "./SantanderFisico.vue?vue&type=script&lang=js&"
import style0 from "./SantanderFisico.vue?vue&type=style&index=0&id=21d8e753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8e753",
  null
  
)

export default component.exports